var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPurpleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 299,
    height: 300,
    viewBox: "0 0 299 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Web_1920_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 299,
    height: 300
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Web_1920_1",
    "data-name": "Web 1920 \\u2013 1",
    clipPath: "url(#clip-Web_1920_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 299,
    height: 300,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Tycho_-_Awake",
    width: 300,
    height: 300,
    fill: "#0c85d5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 92.5,
    cy: 92.5,
    r: 92.5,
    transform: "translate(57 42)",
    fill: "#130f40"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(87.191 -1188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M-118.8-227.258l1.575.09a3.352,3.352,0,0,1-.009,4.848c-2.363.272-2.6,1.958-2.6,3.846q.024,5.035,0,10.071a25.773,25.773,0,0,1-.123,3.35,3.39,3.39,0,0,1-3.6,3.147,3.518,3.518,0,0,1-3.829-2.938,20.95,20.95,0,0,1-.231-4.288c-.014-14.708,0-29.415-.024-44.122,0-1.828.583-4.007-2.059-4.728a3.272,3.272,0,0,1,0-4.735c2.2-.7,2.085-2.5,2.078-4.292q-.033-8.37,0-16.738a8.508,8.508,0,0,1,.425-3.762,3.643,3.643,0,0,1,3.848-2.24,3.28,3.28,0,0,1,3.332,2.842,10.26,10.26,0,0,1,.173,1.9q-.068,28.207-.153,56.416A1.409,1.409,0,0,0-118.8-227.258Z",
    transform: "translate(178 1569)",
    fill: "#f30179"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M-160.423-278.084c-3.606,5.831-6.837,11.833-8.492,18.557-4.1,16.66-.8,31.852,9.064,45.744l2.47,3.48c.736,2.909,2.082,6.013-2.33,7.273a54.776,54.776,0,0,1-17.5-33.24c-2.108-14.059-.664-27.762,6.429-40.451,1.4-2.5,2.723-5.074,4.839-7.1a3.945,3.945,0,0,1,.753-.9l.009-.013a4.279,4.279,0,0,0,.9-1.073l-.061.071a2,2,0,0,0,.981-1.188,2.346,2.346,0,0,1,1.324-1.584c4.483,1.8,3,5.506,2.818,8.8l.065-.1C-160.082-279.6-159.8-278.508-160.423-278.084Z",
    transform: "translate(178 1569)",
    fill: "#fd0178"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M-68.779-287.726c8.707,8.891,13.059,19.833,14.83,31.921a60.16,60.16,0,0,1-1.788,26.024,14.5,14.5,0,0,1-1.371,3.541,3.778,3.778,0,0,1-4.546,1.773,3.7,3.7,0,0,1-2.879-3.907,15,15,0,0,1,.542-3.279c4.735-17.425,1.858-33.434-8.86-48a3.78,3.78,0,0,1-.354-.877,8.22,8.22,0,0,1-.25-5.574C-72.691-289.053-71.206-289.7-68.779-287.726Z",
    transform: "translate(178 1569)",
    fill: "#d7017c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M-117.23-222.32q0-2.424.009-4.848c1.654-1.517,1.209-3.528,1.213-5.4q.036-17.955.014-35.911a32.081,32.081,0,0,1,.067-3.826c.326-2.709,1.625-3.994,3.857-4.024,2.287-.03,3.655,1.183,3.92,3.906.216,2.215.1,4.463.11,6.7.018,2.873-.013,5.746.043,8.618.044,2.222,1.4,2.606,3.26,2.155,1.076,2.938-.323,4.679-2.844,5.877-.913,3.954-.358,7.965-.433,11.948-.1,5.275-.027,10.554-.024,15.831a8.132,8.132,0,0,1-.722,4.2,3.554,3.554,0,0,1-3.7,1.674,3.483,3.483,0,0,1-3.173-2.5C-116.193-219.38-115.719-221.213-117.23-222.32Z",
    transform: "translate(178 1569)",
    fill: "#ea037b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M-129.691-262.717q0,2.369,0,4.735c-2.03.959-1.76,2.8-1.759,4.551,0,7.506.018,15.011-.006,22.517-.013,4.3-1.059,6.064-3.593,6.23-2.751.181-4.146-1.853-4.155-6.221q-.032-16.289-.006-32.577c0-.479-.022-.96.007-1.437.188-3.088,1.329-4.581,3.675-4.65,2.495-.074,3.937,1.184,4.021,3.7A3.743,3.743,0,0,0-129.691-262.717Z",
    transform: "translate(178 1569)",
    fill: "#fc0278"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M-159.225-279.706c-.453-1.844-1.414-3.566-1.193-5.572a3.143,3.143,0,0,0-1.625-3.227c6.989-8.064,15.27-14.209,25.635-17.259,1.861,2.614,1.519,5.471.919,8.355C-144.854-293.456-152.425-287.1-159.225-279.706Z",
    transform: "translate(178 1569)",
    fill: "#f50179"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M-97.063-195.434c6.926-3.35,13.432-7.316,18.906-12.811a5.618,5.618,0,0,1,1.513-1.16c1.91-.894,3.746-.828,5.217.862a3.7,3.7,0,0,1,.168,5.218,40.534,40.534,0,0,1-9,7.835c-5.2,3.434-10.565,6.547-16.765,7.859C-99.041-190.221-98.868-192.823-97.063-195.434Z",
    transform: "translate(178 1569)",
    fill: "#e0027c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M-107.581-249.075c1.94-1.479,1.767-3.981,2.844-5.877.252-1.078.476-2.163.763-3.232.535-2,1.93-2.761,3.912-2.675a3.409,3.409,0,0,1,3.485,3.253,78,78,0,0,1,.2,8.531c-.021,2.241.861,3.268,3.16,2.784a7.646,7.646,0,0,1-2.835,5.883c-.109,1.585-.166,3.175-.338,4.753-.3,2.771-1.929,4.522-4.054,4.465s-3.684-1.783-3.815-4.665c-.158-3.5-.08-7.006-.069-10.509C-104.325-248.61-105.277-249.634-107.581-249.075Z",
    transform: "translate(178 1569)",
    fill: "#e1047d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M-68.779-287.726c-1.647-.407-3.334-1.183-3.4,1.777a32.493,32.493,0,0,1-1.021,5.413A68.559,68.559,0,0,0-95.163-297.2c-.407-2.887-.646-5.732,1.987-7.851C-83.293-301.744-75.387-295.649-68.779-287.726Z",
    transform: "translate(178 1569)",
    fill: "#df027c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M-135.489-297.409c-1.611-2.641-.669-5.564-.919-8.355a2.979,2.979,0,0,1,1.961-.761.814.814,0,0,0,.9-.164c7.614-2.342,15.341-3.448,23.291-2.147-3.055,1.686-2.353,5.356-4.087,7.74A72.772,72.772,0,0,0-135.489-297.409Z",
    transform: "translate(178 1569)",
    fill: "#ec027a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M-159.711-203.03c2.118-1.994,2.1-4.671,2.33-7.273a70.207,70.207,0,0,0,21.114,14.763c-1.034,2.111-.928,4.578-2.077,6.653A48.813,48.813,0,0,1-159.711-203.03Z",
    transform: "translate(178 1569)",
    fill: "#f5037a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M-114.341-301.1c0-1.256-.024-2.512.008-3.767.09-3.457.1-3.457,4.078-3.972a37,37,0,0,1,17.079,3.779c-1.265,2.465-.295,5.495-1.987,7.851l-.985-.249c-.424-.189-.754-.567-1.248-.615A130.14,130.14,0,0,0-114.341-301.1Z",
    transform: "translate(178 1569)",
    fill: "#e6027b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M-138.344-188.887c-.171-2.487-1.305-5.275,2.077-6.653a71.8,71.8,0,0,0,27.652,3.083,1.883,1.883,0,0,1-2.3,1.851c-4.422-.473-6.063,2.332-7.271,5.781A46.025,46.025,0,0,1-138.344-188.887Z",
    transform: "translate(178 1569)",
    fill: "#ee037a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M-118.181-184.825c0-.159,0-.318,0-.476.041-6.7-.6-6.388,5.987-6.351,1.24.007,2.57.277,3.578-.805l11.552-2.977.043,7.8a42.238,42.238,0,0,1-19.51,2.885,1.536,1.536,0,0,1-1.058-.059l-.3.162Z",
    transform: "translate(178 1569)",
    fill: "#e7027b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M-96.055-240.408c1.009-1.93.585-4.551,2.835-5.883.907-1.612.543-3.408.753-5.123.269-2.189,1.515-3.5,3.754-3.521a3.514,3.514,0,0,1,3.821,3.471c.22,4.272.176,8.567.03,12.845a3.611,3.611,0,0,1-3.342,3.508,3.463,3.463,0,0,1-4.19-2.959C-92.819-240.279-93.9-241.09-96.055-240.408Z",
    transform: "translate(178 1569)",
    fill: "#d8047e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M-160.423-278.084c.068-.832.291-1.549,1.262-1.718A2.271,2.271,0,0,1-160.423-278.084Z",
    transform: "translate(178 1569)",
    fill: "#f50179"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M-117.588-184.8l1.059.06C-116.9-184.371-117.253-184.478-117.588-184.8Z",
    transform: "translate(178 1569)",
    fill: "#ee037a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M-118.8-227.258a1.474,1.474,0,0,1-1.194-1.332Q-119.393-227.926-118.8-227.258Z",
    transform: "translate(178 1569)",
    fill: "#ea037b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M-165.192-284.718l-.753.9A.864.864,0,0,1-165.192-284.718Z",
    transform: "translate(178 1569)",
    fill: "#f50179"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M-164.287-285.8l-.9,1.073A1.141,1.141,0,0,1-164.287-285.8Z",
    transform: "translate(178 1569)",
    fill: "#f50179"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M-163.367-286.921a1.468,1.468,0,0,1-.981,1.188A1.435,1.435,0,0,1-163.367-286.921Z",
    transform: "translate(178 1569)",
    fill: "#f50179"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M-97.4-298.069l1.248.616A1.207,1.207,0,0,1-97.4-298.069Z",
    transform: "translate(178 1569)",
    fill: "#df027c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M-133.545-306.689c-.228.451-.516.575-.9.164A.848.848,0,0,1-133.545-306.689Z",
    transform: "translate(178 1569)",
    fill: "#f50179"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 241,
    height: 42,
    transform: "translate(31 245)",
    fill: "#0c85d5"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleIcon);
export default __webpack_public_path__ + "static/media/purple-icon.82f1ec5098c9cf152c20e1ab521ce379.svg";
export { ForwardRef as ReactComponent };